import React from 'react';

const LoginHeader = () => {
  return (
    <div className="text-center space-y-4 mb-8">
      <div className="flex flex-col items-center gap-3">
        <img 
          src="/assets/images/90A19BF4-3446-4543-87E4-2148054C81C1-1768952058269.jpeg" 
          alt="OfferSense Logo" 
          className="w-24 h-24 md:w-32 md:h-32 object-contain" 
        />
        <h1 className="text-3xl md:text-4xl header-logo-text">
          <span className="text-[#2C3E5F]">OfferSense</span>
          <span className="text-[#5DBFB3]">.Ai</span>
        </h1>
      </div>
      
      <div className="space-y-2">
        <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-md mx-auto">
          Sign in to your OfferSense account to manage properties and compare offers
        </p>
      </div>
    </div>
  );
};

export default LoginHeader;